<template>
    <v-scale-transition>
        <v-card flat tile color="transparent" v-show="visible">
            <v-card flat tile class="pt-5 pb-5" color="transparent" max-width="700">
                <text-editor v-if="editable"
                             v-model="textModel"
                             hint="Footer text">

                    <div class="markdown footer grey--text" v-html="html">
                    </div>

                </text-editor>
                <div v-else>
                    <div class="markdown footer grey--text" v-html="html">
                    </div>
                </div>
            </v-card>
        </v-card>
    </v-scale-transition>
</template>

<script>

    import TextEditor from "../TextEditor";
    import policyLinkHelperMixin from "../../mixins/policyLinkHelperMixin";

    export default {

        mixins: [policyLinkHelperMixin],

        components: {
            TextEditor,
        },

        props: {

            value: {
                type: String | null,
                required: true,
            },

            visible: {
                type: Boolean,
                required: false,
                default: true,
            },

            subPanelId: {
                type: Number,
                required: true,
            },

            locale: {
                type: String,
                required: true,
            },

            editable: {
                type: Boolean,
                required: false,
                default: true,
            }
        },

        computed: {

            textModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },

            html() {

                if (this.value) {
                    return this.replaceVariables(
                        this.value,
                        'markdown grey--text',
                        this.subPanelId,
                        this.locale
                    );
                }
            }
        }
    }
</script>

<style scoped>

.footer {
    margin-top: 0px;
    font-size: 12px
}

</style>